import store from "@/store";
import {
  round
} from 'lodash'
const getTootipFormatter = (indicators) => {
  let that = this
  return function (params) {
    console.log('%c 🥫 params: ', 'font-size:20px;background-color: #EA7E5C;color:#fff;', params.type);
    let data = params.data

    if(data.district=='其他'){
      data.district='其它：由免费版和试用版自动生成的license'
      let str = (data.time || data.type || data.district) + '</br>' + indicators.name + ': ' + round(data[indicators.field])+ indicators.unit
      return str
    }
    
    let str = (data.time || data.type || data.district) + '</br>' + indicators.name + ': ' + round(data[indicators.field])+ indicators.unit
    return str
  }
}
const loadingOpts = {
  text: '',
  color: 'rgba(0, 145, 255, 1)',
  textColor: '#000',
  maskColor: 'rgba(255, 255, 255, 1)',
  zlevel: 0,
  fontSize: 20,
  lineWidth: 3

}
const bar = {
  basic: {
    grid: {
      containLabel: true,
      left: 5,
      top: 10,
      right: 0,
      bottom: 24
    },
    tooltip: {
      textStyle: {
        color: "#888888"
      },
    },
    legend: {
      show: true,
      bottom: 15,
      itemWidth: 10,
      itemHeight: 10,
    },
    xAxis: {
      type: "category",
      splitLine: {
        lineStyle: {
          type: "dotted",
          color: "#c0c0c0"
        }
      },
      axisLabel: {
        formatter:val=>{
          return val
        }
      }
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          type: "dotted",
          color: "#c0c0c0"
        }
      },
      splitNumber: 3,
      axisLabel: {
        formatter: value => {
          let val;
          if (value >= 1000) {
            val = value / 1000 + "k";
          } else if (value < 1000) {
            val = value;
          }
          return val;
        }
      }
    },
    color: ['#0091FF']
  },
  noData: {
    grid: {
      containLabel: true,
      left: 5,
      top: 10,
      right: 0,
      bottom: 20
    },
    tooltip: {
      show: false
    },
    xAxis: {
      show:false
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          type: "dotted",
          color: "#c0c0c0"
        }
      },
      splitNumber: 3
    },
    series: [{
      type: "bar",
      data: [0]
    }]
  }
}
const pie = {
  noData: {
    title: {
      text: '',
      top: 'middle',
      left: 'center',
      textStyle: {
        color: '#4E4E4E',
        fontWeight: 'normal',
        fontSize: 12
      }
    },
    legend: {
      show: false
    },
    credits: {
      enabled: false
    },
    tooltip: {
      show: false
    },
    series: [
      {
        type: 'pie',
        radius: ['50%', '80%'],
        color: '#eaeaea',
        avoidLabelOverlap: false,
        selectedMode: 'single',
        label: {
          show: true,
          position: 'center',
          color: '#888'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '12',
            fontWeight: 'bold'
          }
        },
        data: [
          { value: 0,
            name: '暂无数据',
            itemStyle: {
              normal: { color: '#eaeaea' },
              emphasis: { color: '#eaeaea' }
            }
          }
        ]
      }
    ]
  }
}

export {
  bar,
  pie,
  loadingOpts,
  getTootipFormatter
};